<template>
  <div class="mk-contact">
    <div class="mk-contact__container">
       <button
        class="mk-contact__close"
        @click="() => closeCallback()"
      >
        X
      </button>
      <span class="mk-contact__title">
        {{$t('contact.contactTitle')}}
      </span>
      <span class="mk-contact__subtitle">
        {{$t('contact.contactSubtitle')}}
      </span>

      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="library" class="mk-contact__label">
            {{$t('contact.libraryPlaceholder')}}
          </label>
          <span class="mk-contact__field__error">{{error.library}}</span>
          <input
            @change="() => checkNotEmpty('library')"
            :placeholder="$t('contact.libraryPlaceholder')"
            class="mk-contact__input"
            :class="error.library ? 'mk-contact__input--error' : ''"
            id="library"
            type="text"
            v-model="library"
          />
        </div>
        <div class="mk-contact__field">
          <label for="title" class="mk-contact__label">
            Salutation
          </label>
          <span class="mk-contact__field__error">{{error.title}}</span>
          <select
            @change="() => checkNotEmpty('title')"
            class="mk-contact__select"
            :class="error.title ? 'mk-contact__input--error' : ''"
            id="title"
            v-model="title"
          >
            <option value="" selected>
              {{$t('contact.salutationPlaceholder')}}
            </option>
            <option value="Mr">
              Mr.
            </option>
            <option value="Ms">
              Ms.
            </option>
            <option value="Mrs">
              Mrs.
            </option>
          </select>
        </div>
      </div>
      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="first" class="mk-contact__label">First Name</label>
          <span class="mk-contact__field__error">{{error.first}}</span>
          <input
            @change="() => checkNotEmpty('first')"
            :placeholder="$t('contact.firstNamePlaceholder')"
            class="mk-contact__input"
            :class="error.first ? 'mk-contact__input--error' : ''"
            id="first"
            type="text"
            v-model="first"
          />
        </div>
        <div class="mk-contact__field">
          <label for="last" class="mk-contact__label">Last Name</label>
          <span class="mk-contact__field__error">{{error.last}}</span>
          <input
            @change="() => checkNotEmpty('last')"
            :placeholder="$t('contact.lastNamePlaceholder')"
            class="mk-contact__input"
            :class="error.last ? 'mk-contact__input--error' : ''"
            id="last"
            type="text"
            v-model="last"
          />
        </div>
      </div>
      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="email" class="mk-contact__label">Email</label>
          <span class="mk-contact__field__error">{{error.email}}</span>
          <input
            @change="emailUpdated"
            :placeholder="$t('contact.emailPlaceholder')"
            class="mk-contact__input"
            :class="error.email ? 'mk-contact__input--error' : ''"
            id="email"
            type="text"
            v-model="email"
          />
        </div>
        <div class="mk-contact__field">
          <label for="phone" class="mk-contact__label">Phone</label>
          <span class="mk-contact__field__error">{{error.phone}}</span>
          <input
            :placeholder="$t('contact.phonePlaceholder')"
            class="mk-contact__input"
            id="phone"
            type="text"
            v-model="phone"
          />
        </div>
      </div>
      <span class="mk-contact__message__label">
        {{$t('contact.shippingText')}}:
      </span>
      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <span class="mk-contact__field__error">{{error.country}}</span>
          <country-select
            @change="() => checkNotEmpty('country')"
            :placeholder="$t('contact.countryPlaceholder')"
            class="mk-contact__select"
            :class="error.country ? 'mk-contact__select' : ''"
            v-model="country"
            :country="country"
            :topCountry="itemData.area"
          />
        </div>
        <div class="mk-contact__field" v-if="country === 'US' || country === 'CA'">
          <span class="mk-contact__field__error">{{error.region}}</span>
          <region-select
            @change="() => checkNotEmpty('region')"
            class="mk-contact__select"
            :class="error.region ? 'mk-contact__select' : ''"
            v-model="region"
            :country="country"
            :region="region"
            :placeholder="$t('contact.statePlaceholder')"
            :blackList="['AA','AP', 'AE']"
          />
        </div>
      </div>
       <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="street" class="mk-contact__label">Street Address</label>
          <span class="mk-contact__field__error">{{error.street}}</span>
          <input
            @change="() => checkNotEmpty('street')"
            :placeholder="$t('contact.streetPlaceholder')"
            class="mk-contact__input mk-contact__input__street"
            :class="error.street ? 'mk-contact__input--error' : ''"
            id="street"
            type="text"
            v-model="street"
          />
        </div>
      </div>
      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="city" class="mk-contact__label">City</label>
          <span class="mk-contact__field__error">{{error.city}}</span>
          <input
            @change="() => checkNotEmpty('city')"
            :placeholder="$t('contact.cityPlaceholder')"
            class="mk-contact__input"
            :class="error.city ? 'mk-contact__input--error' : ''"
            id="city"
            type="text"
            v-model="city"
          />
        </div>
        <div class="mk-contact__field">
          <label for="zip" class="mk-contact__label">Zip Code</label>
          <span class="mk-contact__field__error">{{error.zip}}</span>
          <input
            @change="() => checkNotEmpty('zip')"
            :placeholder="$t('contact.zipPlaceholder')"
            class="mk-contact__input"
            :class="error.zip ? 'mk-contact__input--error' : ''"
            id="zip"
            type="text"
            v-model="zip"
          />
        </div>
      </div>
      <label for="message" class="mk-contact__label">Message</label>
      <textarea
        :placeholder="$t('contact.messagePlaceholder')"
        class="mk-contact__message"
        id="message"
        v-model="message"
      />
      <label for="files" class="mk-contact__message__label">
        {{$t('contact.attachmentText')}}:
      </label>
      <multi-source-file-input v-model="files"/>
      <button
        class="mk-contact__send"
        @click="sendForm"
      >
        {{$t('contact.send')}}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Contact Popup
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows the main contact form.
 * It enables the user to send a rewuest to mk-solutions.
 */
import { sendContact } from '../helpers/api';

export default {
  props: {
    closeCallback: Function,
    itemData: Object,
    offerId: String,
  },
  data() {
    return {
      files: [],
      message: '',
      first: '',
      last: '',
      phone: '',
      library: '',
      title: '',
      email: '',
      country: '',
      region: '',
      zip: '',
      city: '',
      street: '',
      error: {
        email: '',
        library: '',
        title: '',
        first: '',
        last: '',
        country: '',
        region: '',
        zip: '',
        city: '',
        street: '',
      },
    };
  },
  methods: {
    sendForm() {
      Object.keys(this.error).forEach((key) => this.checkNotEmpty(key));
      if (Object.keys(this.error).some((error) => this.error[error] !== '')) {
        return;
      }
      console.log('send');
      sendContact(
        this.files,
        {
          ...this.itemData,
          firstName: this.first,
          lastName: this.last,
          salutation: this.title,
          phone: this.phone,
          library: this.library,
          country: this.country,
          region: this.region,
          zip: this.zip,
          city: this.city,
          street: this.street,
          email: this.email,
          offerId: this.offerId,
          message: this.message,
          link: window.location.href,
        },
      ).then(() => {
        this.closeCallback(true);
      }).catch(() => {
        this.closeCallback(false);
      });
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
      return re.test(String(email).toLowerCase());
    },
    emailUpdated() {
      if (this.validateEmail(this.email)) {
        this.error.email = '';
        return;
      }
      this.error.email = this.$t('contact.errorEmail');
    },
    checkNotEmpty(key) {
      if (key === 'region' && (this.country !== 'US' || this.country !== 'CA')) {
        this.error[key] = '';
        return;
      }
      if (this[key] !== '') {
        this.error[key] = '';
        return;
      }
      this.error[key] = this.$t('contact.errorField');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-contact {
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($c_primary, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  &__title {
    margin: 10px;
    font-size: 20px;
    font-weight: 500;
  }

  &__subtitle {
    color: $c_primary_lighter;
    margin: 10px 0;
  }

  &__row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }

  &__field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 5px 5px;
    width: 100%;

    &__error {
      font-size: 12px;
      color: $c_accent;
    }
  }

  &__label {
    display: none;
  }

  &__input {
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;

    &__street {
      width: 100%;
    }

    &:focus {
      border: 1px solid $c_primary_lighter;
    }

    &--error {
      border: 1px solid $c_accent;
    }
  }

  &__send {
    margin-top: 10px;
    width: 50%;
    align-self: center;
    background-color: $c_accent;
    box-shadow: $bs_md;
    padding: 10px 20px;
    border: none;
    border-radius: $br_md;
    color: $c_white;
    text-transform: uppercase;
  }

  &__close {
    background-color: $c_white;
    box-shadow: $bs_md;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
  }

  &__message {
    margin: 5px 5px;
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;
    min-height: 70px;

    &__label {
      align-self: flex-start;
      margin: 10px 5px;
      color: $c_accent;
      font-weight: 500;
    }
  }

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    background-color: $c_white;
    max-height: 720px;
    overflow: auto;
  }

  &__select {
    width: 100%;
    flex-grow: 1;
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;
    max-width: 250px;

    &__error {
      border: 1px solid $c_accent;
    }
  }
}
</style>
